import { createContext, FC } from 'react';

import I18n from 'lib/utils/i18n';

const I18nContext = createContext<I18n>(new I18n({}, false, '', ''));

interface I18nProviderProps {
  i18n: I18n;
}

export const I18nProvider: FC<I18nProviderProps> = ({ children, i18n }) => (
  <I18nContext.Provider value={i18n}>{children}</I18nContext.Provider>
);

export default I18nContext;
